import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { AlertCircle, CheckCircle } from "lucide-react";
import { API } from "../constants";

const OrderConfirmation = () => {
  const [searchParams] = useSearchParams();
  const [paymentStatus, setPaymentStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(`${API}/checkout/status/${sessionId}`);
      if (response.data.payment_status === 'paid') {
        setPaymentStatus('success');
      } else if (response.data.status === 'expired') {
        setPaymentStatus('failed');
      } else {
        setTimeout(checkPaymentStatus, 2000);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentStatus('error');
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center">
      {paymentStatus === 'checking' && (
        <div data-testid="payment-checking">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-orange-500 mx-auto mb-6"></div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Processing Payment...</h1>
          <p className="text-gray-600">Please wait while we confirm your payment.</p>
        </div>
      )}

      {paymentStatus === 'success' && (
        <div data-testid="payment-success">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Order Confirmed!</h1>
          <p className="text-xl text-gray-600 mb-8">
            Thank you for your order. We'll send you a proof within 24 hours via email.
          </p>
          <Button onClick={() => window.location.href = '/'} data-testid="continue-btn">
            Continue Shopping
          </Button>
        </div>
      )}

      {paymentStatus === 'failed' && (
        <div data-testid="payment-failed">
          <AlertCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Payment Failed</h1>
          <p className="text-xl text-gray-600 mb-8">
            Your payment session has expired. Please try again.
          </p>
          <Button onClick={() => window.location.href = '/cart'} data-testid="retry-btn">
            Try Again
          </Button>
        </div>
      )}
    </div>
  );
};

// Design Services Page (same as before)

export { OrderConfirmation };
export default OrderConfirmation;
